<template>
  <b-modal
    v-model="showModal"
    @hide="e => {cancelHide(e)}"
    :hide-footer="true"
    :hide-header-close="true"
    :hide-header="true"
    size="lg"
    body-class="p-0"
    body-bg-variant
    class="modal-lg setup-modal"
  >
    <b-row class="no-gutters">
      <b-col md="6">
        <div class="d-flex flex-column align-items-center bg-light text-primary py-4 px-5">
          <img src="@/../src/assets/images/setup_icon.svg" alt="Setup" class="mb-2">
          <h2 class="font-weight-light text-center">{{$t(`onboarding.step${page}_header_title`)}}</h2>
          <p class="text-center mb-0 small" v-html="$t(`onboarding.step${page}_header_desc`)"></p>
        </div>
        <div class="py-4 px-4">
          <slot name="body"/>
        </div>
      </b-col>
      <b-col md="6"
             class="step-list-container text-white px-5 pt-5 pb-2 d-none d-md-flex flex-column justify-content-between">
        <ul class="pt-4 mt-3 pr-5">
          <li v-for="(item, index) in 3" :class="{disabled : !ifActive(index) }">
            <div class="d-flex flex-row">
              <span
                class="rounded-circle border border-white d-flex justify-content-center align-items-center flex-shrink-0"
                style="height: 48px; width: 48px;"
              ><h5 class="mb-0">{{index + 1}}</h5></span>
              <div class="ml-4 mb-3">
                <h3 class="font-weight-light">{{$t(`onboarding.step${index+1}_title`)}}</h3>
                <p>
                <p class="small">{{$t(`onboarding.step${index+1}_desc`)}}</p>
              </div>
            </div>
          </li>
        </ul>
        <div class="d-flex">
          <i class="fas fa-question-circle disabled fa-2x"></i>
          <div class="ml-4">
            <h6 class="disabled mb-1">{{$t('onboarding.help')}}</h6>
            <p class="small">
              <span class="disabled">{{$t('onboarding.mail_us')}}</span>
              <a class="text-white" href="mailto:help@wallkit.net" target="_blank"> help@wallkit.net </a>
              <span class="disabled">{{$t('onboarding.call_us')}}</span>
              <a class="text-white" href="tel:1 646 520 4672"> +1 646 520 4672</a>
            </p>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>

  export default {
    name: "onboardingModal",
    props: {
      step: {
        type: Number,
        required: true
      },
      type: {
        type: String
      }
    },
    data() {
      return {
        showModal: true
      }
    },
    methods: {
      ifActive(index) {
        return this.step === index + 1
      },
      cancelHide(e) {
        e.preventDefault()
      }
    },
    computed: {
      page() {
        if (this.type) {
          return `${this.step}_${this.type}`
        } else {
          return this.step
        }
      }
    }
  }
</script>